// The app-wide toast channel: any surface fires a `pomela:toast` CustomEvent, and the shell (V2Shell) turns it into a
// visible toast. Fire-and-forget, so a surface needs no toast host of its own.
import { useEffect } from 'preact/hooks';
import { useToast } from '@vibeshell/hooks';

/** Dispatch the app-wide toast event (the same channel AppCard's Share uses). */
export function emitPomelaToast(kind: 'success' | 'error', message: string): void {
  window.dispatchEvent(new CustomEvent('pomela:toast', { detail: { kind, message } }));
}

/**
 * Bridge `pomela:toast` CustomEvents into the visible ToastHost bus. Mounted once, by the shell, so every routed
 * surface gets REAL, near-the-action toasts instead of silent events.
 */
export function usePomelaToastBridge(): void {
  const toast = useToast();
  useEffect(() => {
    const onToast = (e: Event): void => {
      const detail = (e as CustomEvent).detail as { kind?: string; message?: string } | undefined;
      if (!detail?.message) return;
      toast.show(detail.message, {
        variant: detail.kind === 'success' ? 'success' : detail.kind === 'error' ? 'error' : 'neutral'
      });
    };
    window.addEventListener('pomela:toast', onToast);
    return () => window.removeEventListener('pomela:toast', onToast);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
